<template>
  <section class="section has-background-light fullheight-min">
    <div class="container">
      <slot></slot>
      <h2 class="title">Просмотр объекта</h2>
      <div class="table-container">
        <table class="table borderless is-hoverable transparent"  >
          <tbody>
            <tr v-for="(row, field) in pk" :key="field">
              <th>{{$tc(field)}}</th>
              <td @click.self="clickField(field, $event)">
                <template v-if="editedField != field" >
                  <div class="tags" v-if="Array.isArray(row)" @click="clickField(field, $event)">
                    <span class="tag" v-for="(item, index) in row" :key="index">{{item.title || item.name || item.pk || item}}</span>
                  </div>
                  <span v-else @click="clickField(field, $event)">{{row || '-'}}</span>
                </template>
                <template v-else>
                  <div class="field is-grouped is-grouped-multiline input" v-if="Array.isArray(row)">
                    <div class="control">
                      <div class="tags">
                        <div class="tag" v-for="(item, index) in row" :key="index">
                          {{item.title || item.name || item.pk || item}}
                          <button class="delete is-small" ></button>
                        </div>
                      </div>

                    </div>
                    <div class="control">
                      <input class="" type="text" name="" id="">
                    </div>

                  </div>
                  <input class="input is-small" type="text" v-else>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  metaInfo () {
    return {
      title: this.$_.upperFirst(this.$tc(this.$route.meta.title))
    }
  },
  data () {
    return {
      pk: {},
      editedField: null
    }
  },
  created () {
    this.getData()
  },
  methods: {
    clickField (field) {
      if (this.editedField === null) {
        this.editedField = field
      } else this.editedField = null
    },
    getData () {
      try {
        this.$store.dispatch('user/getMe')
          .then(() => {
            const data = {}
            const me = this.$store.state.user.me
            for (const [key, field] of Object.entries(me)) {
              if (field && typeof field !== 'string' && !Array.isArray(field) && Object.keys(field).length > 0) {
                for (const key1 in field) {
                  data[key1] = field[key1]
                }
              } else data[key] = field
            }
            this.pk = me
          })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
